import React, { useState, useEffect } from 'react';

const PatientSearch = ({ onSelectPatient }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    // Simular carregamento de uma lista de pacientes
    setPatients([
      { id: 1, name: 'João Silva', cpf: '123.456.789-00' },
      { id: 2, name: 'Maria Oliveira', cpf: '987.654.321-00' },
      { id: 3, name: 'Carlos Souza', cpf: '456.123.789-00' },
    ]);
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSelect = (patient) => {
    onSelectPatient(patient);
  };

  const filteredPatients = patients.filter(
    (patient) =>
      patient.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      patient.cpf.includes(searchTerm)
  );

  return (
    <div className="max-w-2xl mx-auto mb-6">
      <div className="relative">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Buscar paciente por nome ou CPF"
          className="w-full p-4 text-lg border border-gray-300 rounded-full shadow-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
        />
        <svg
          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          width="24"
          height="24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-4.35-4.35M16 10a6 6 0 10-12 0 6 6 0 0012 0z"
          />
        </svg>
      </div>

      {filteredPatients.length > 0 && (
        <ul className="mt-4 bg-white shadow-lg rounded-lg">
          {filteredPatients.map((patient) => (
            <li
              key={patient.id}
              className="p-4 border-b hover:bg-gray-50 cursor-pointer"
              onClick={() => handleSelect(patient)}
            >
              {patient.name} - {patient.cpf}
            </li>
          ))}
        </ul>
      )}

      {filteredPatients.length === 0 && searchTerm && (
        <p className="mt-4 text-gray-500">Nenhum paciente encontrado.</p>
      )}
    </div>
  );
};

export default PatientSearch;
